import React, { useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { CustomDropdown } from '../deps.js';
import AdminModal from '../AdminModal.js';

const AddUserModal = ({ isOpen, onClose, onSubmit, roles, clinics, loading }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [clinicId, setClinicId] = useState('');
  const [roleDropdownOpen, setRoleDropdownOpen] = useState(false);
  const [clinicDropdownOpen, setClinicDropdownOpen] = useState(false);
  const roleDropdownRef = useRef(null);
  const clinicDropdownRef = useRef(null);
  const pickClinic = Array.isArray(clinics);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email.trim() === '' || name.trim() === '' || role === '' || (pickClinic && clinicId === '')) {
      alert('All fields are required');
      return;
    }
    onSubmit(email.trim().toLowerCase(), name, role, pickClinic ? clinicId : undefined);
  };

  const selectedClinicName = pickClinic
    ? (clinics.find((clinic) => clinic.clinicId === clinicId)?.clinicName || 'Select Clinic')
    : '';

  return (
    <AdminModal
      isOpen={isOpen}
      onClose={onClose}
      title="Add New User"
      containerClassName="admin-add-user-modal"
      actions={(
        <>
          <button className="admin-modal-cancel-button" onClick={onClose}>Cancel</button>
          <button
            className="admin-submit-button"
            onClick={handleSubmit}
            disabled={loading || !email || !name || !role || (pickClinic && !clinicId)}
          >
            {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Add User'}
          </button>
        </>
      )}
    >
      <form onSubmit={handleSubmit}>
        {pickClinic && (
          <div className="admin-form-group">
            <label>Clinic:</label>
            <CustomDropdown
              selected={selectedClinicName}
              options={clinics.map((clinic) => ({
                id: clinic.clinicId,
                display: clinic.clinicName,
                value: clinic.clinicId,
              }))}
              isOpen={clinicDropdownOpen}
              toggleDropdown={() => setClinicDropdownOpen(!clinicDropdownOpen)}
              onSelect={(option) => {
                setClinicId(option.value);
                setClinicDropdownOpen(false);
              }}
              className="admin-clinic-picker"
              containerRef={clinicDropdownRef}
              keyExtractor={(option) => option.id}
            />
          </div>
        )}
        <div className="admin-form-group">
          <label>Role:</label>
          <CustomDropdown
            selected={role ? (roles[role]?.title || role) : 'Select Role'}
            options={
              Object.entries(roles)
                .map(([roleId, roleData]) => ({
                  id: roleId,
                  display: roleData.title || roleId,
                  value: roleId,
                }))
                .sort((a, b) => a.display.localeCompare(b.display))
            }
            isOpen={roleDropdownOpen}
            toggleDropdown={() => setRoleDropdownOpen(!roleDropdownOpen)}
            onSelect={(option) => {
              setRole(option.value);
              setRoleDropdownOpen(false);
            }}
            className="admin-role-select"
            containerRef={roleDropdownRef}
            keyExtractor={(option) => option.id}
          />
        </div>
        <div className="admin-form-group">
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="user@example.com"
          />
        </div>
        <div className="admin-form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            placeholder="Full Name"
          />
        </div>
      </form>
    </AdminModal>
  );
};

export default AddUserModal;
